import { MapType } from '../models/expressionTypes';
import { CallPlainObject } from '../plainObjects/call.plainObject';
import { ExpressionColumnPlainObject } from '../plainObjects/expressionColumn.plainObject';
import { MatchFunctionUtil } from '../utils/matchFunction.util';
import { SchemaUtil } from '../utils/schema.util';
import { ColumnMapVisitor } from './columnMap.visitor';
import { ExpressionVisitor } from './expression.visitor';

/* eslint-disable @typescript-eslint/no-explicit-any */
export class CallVisitor extends ColumnMapVisitor {

    private get _callTransformation(): CallPlainObject {
        return this.transformation as CallPlainObject;
    }

    public visitOutputDefinition(outputDefinitionContext: any): void {
        const outputDefinition = SchemaUtil.getSchemaFromInputOutputDefinition(outputDefinitionContext);
        this._callTransformation.outputDefinition = outputDefinition;
    }

    public visitConfiguration(context: any): void {
        const configName: string = this._getText(context.configName());
        const configValue = this._getText(context.expression());

        this._callTransformation.configs.set(configName, configValue);
    }

    public visitAssignment(assignment: any): ExpressionColumnPlainObject {
        const column = new ExpressionVisitor(this._tokenStream)?.visit(assignment.expression())?.columnOperand;
        // add to column mapping if assignment is not from settings fields
        if (column && !(column instanceof MapType)) {
            super.visitAssignment(assignment);
        }
        const derivedColumn = new ExpressionColumnPlainObject();
        derivedColumn.name = this._getText(assignment.columnIdentifier());
        derivedColumn.expression = this._getText(assignment.expression());
        this._callTransformation.columns.push(derivedColumn);
        return derivedColumn;
    }

    public visitTransientAssignment(assignment: any): void {
        const visitAssignment = this.visitAssignment(assignment);
        visitAssignment.transient = true;
    }

    public visitMetaFunctionExpr(context: any): void {
        super.visitMetaFunctionExpr(context);
        MatchFunctionUtil.addColumnPatternColumns(this._callTransformation, this._tokenStream, context);
    }
}
